import { Avatar, Button, Stack, Typography } from '@mui/material';
import { IBurgerMenuItem } from 'API/Home/burgerMenuItems';
import { useAppSelector } from 'Hooks';
import { UnreadNotificationsMobile } from 'Images';

interface IUpdatesAndPersonalDetails {
  updatesAndPersonalDetails: IBurgerMenuItem[];
  itemNavigationHandler: Function;
}

export const UpdatesAndPersonalDetails = ({
  updatesAndPersonalDetails,
  itemNavigationHandler,
}: IUpdatesAndPersonalDetails) => {
  const isReadNotifications = useAppSelector(
    ({ imposter: { isReadNotifications } }) => isReadNotifications
  );

  return (
    <Stack
      direction='row'
      sx={{
        justifyContent: 'space-around',
      }}
    >
      {updatesAndPersonalDetails.map(
        (menuItem: IBurgerMenuItem, index: number) => {
          return (
            <Button
              key={index}
              sx={{
                display: 'flex',
                flexFlow: 'column',
                p: 0,
                width: 'fit-content',
                gap: '8px',
                mt: '4px',
              }}
              onClick={() => itemNavigationHandler(menuItem)}
              role='link'
            >
              <Avatar
                sx={{ width: '24px', height: '24px' }}
                src={
                  menuItem.internalLink === 'updates'
                    ? isReadNotifications
                      ? UnreadNotificationsMobile
                      : menuItem.mobileIconUrl
                    : menuItem.mobileIconUrl
                }
                alt=''
              />
              <Typography variant='body3'>{menuItem.description}</Typography>
            </Button>
          );
        }
      )}
    </Stack>
  );
};
